$(document).ready(function(){
  $("form").on("submit", function(e){
    e.preventDefault();
    var form = $(this);
    grecaptcha.ready(function() {
      grecaptcha.execute(captcha_key, {action: 'submit'}).then(function(token) {
        let grecaptchaInput = document.getElementById('id_grecaptcha');
        grecaptchaInput.value = token;

        var validated = true;
        var selected = true;

      $(form).find(".single-input:not(.not-required) .input").each(function(i, e){
        if($(e).val().length < 1){
          $(e).parent().addClass("error");
          validated = false;
        }
        else{
          $(e).parent().removeClass("error");
        }
      });

      $(form).find(".single-input .select").each(function(i, e){
        if($(e).prop("checked") == false){
          $(e).parent().addClass("error");
          selected = false;
        }
        else{
          $(e).parent().removeClass("error");
        }
      });

      if(validated == true && selected == true){
        $.ajax({
          type: $(form).attr("method"),
          url: $(form).attr("action"),
          data: $(form).serialize(),
          success: function(data){
            $(".complaints").addClass("disabled");
            $(".complaints__ThankYou").addClass("active");
            window.scrollTo(0, 0);
            $(form)[0].reset();
          },
          error: function(data){
            if(data.responseJSON.errors) {
              Object.keys(data.responseJSON.errors).forEach(error => {
                let emailField = document.querySelector('input[name="email"]');
                let errorField = $(`#id_${error}`);
                errorField.parent().find(".error-backend").remove();
                let message = document.createElement("p");
                message.classList.add("error-backend");
                data.responseJSON.errors[error].forEach(singleError => {
                  message.innerHTML+=singleError.message
                });
                errorField.parent().append(message);
                if(message) {
                  emailField.addEventListener('input', function() {
                    message.style.display = "none";
                  }, {once : true})
                }
              })
             document.querySelector(".error-backend").parentNode.scrollIntoView({
              behavior: "smooth", block: "center", inline: "center"
             });
            }     
          }
        });
      }
      else{
        $(form).find(".error-message").addClass("active");
      }
      });
    });
  });
});




// WEBPACK FOOTER //
// src/js/bundle/complaints.js